import styled from 'styled-components';

// Version card wrapper — adds spacing around SiteEntry / VisualEditEntry cards
export const EntryCard = styled.div`
	padding: 4px 8px;
`;
